module.exports = __webpack_public_path__ + "static/media/Working Capital.634c0322.jpeg";